// Copyright (c) 2023 Park Hyunwoo
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT

export function word2vec (word: string): number[] {
  // const vec: number[] = new Array(26).fill(0)
  const vec: number[] = [
    0, 0, 0, 0, 0,
    0, 0, 0, 0, 0,
    0, 0, 0, 0, 0,
    0, 0, 0, 0, 0,
    0, 0, 0, 0, 0,
    0
  ] // Faster version
  for (let i = 0; i < word.length; i++) {
    const ch = word.charCodeAt(i)
    if (64 + 1 <= ch && ch <= 64 + 26) vec[ch - 64 - 1]++
    if (96 + 1 <= ch && ch <= 96 + 26) vec[ch - 96 - 1]++
  }
  return vec
}

// ------

export interface KnownWord {
  display: string
  correspondingLatin: string
}

export type WordTable = Map<string, KnownWord[]>
